// settings — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Settings -> Tax -> Tax Rates: the Default marker ---------------------
  'settings.tax.default': 'Default',
  'settings.tax.defaultBadge': 'Default',
  'settings.tax.makeDefault': 'Make default',
  'settings.tax.defaultClear': 'Remove as default',
  'settings.tax.defaultForm': 'Make this the default tax — it applies to every dish that names no tax of its own',
  'settings.tax.defaultHint': 'Default rates ride on every dish that names no tax of its own, on the kiosk and the bill alike.',
  'settings.tax.defaultNone': 'None is marked yet, so every active rate applies.',
  'settings.tax.defaultSaved': 'Default rates updated',
  'settings.tax.yes': 'Yes',
  'settings.tax.no': 'No',
  // --- Reservation settings: table hold while the guest pays -------------
  // --- Reservation settings: the branch these rules belong to (users/0116) --
  'settings.resv.branch': 'Branch',
  'settings.resv.branchOnly': 'Saved for this branch only — switch branch from your account menu, top right.',
  'settings.resv.noBranch': 'No branch selected. Choose one from your account menu, top right, before saving these rules.',
  'settings.resv.usingFallback': 'This branch has no rules of its own yet: it follows the restaurant-wide rules until you save here.',
  'settings.website.branchNeeded': 'Choose which branch the website speaks for (Site tab) before switching its reservations.',
  'settings.website.urls.title': 'Your web addresses',
  'settings.website.urls.hint': 'Served next to this admin on your own domain — for menu cards, social profiles and QR codes.',
  'settings.website.urls.site': 'Public website',
  'settings.website.urls.justbuffets': 'Just Buffets — the open buffets, priced per head by the day',
  'settings.website.urls.open': 'Open',
  'settings.website.urls.copy': 'Copy',
  'settings.website.urls.copied': 'Copied',
  'settings.hold.payTitle': 'Table hold while the guest pays',
  'settings.hold.payHint': 'With a booking amount on, a website booking takes its table the moment it is made. This is how long it keeps it without paying.',
  'settings.hold.minutes': 'Hold the table for',
  'settings.hold.minutesHint': 'Counted from the moment the booking is made. 0 turns the clock off — the booking then waits for staff, as it always did.',
  'settings.party.title': 'Party size',
  'settings.party.hint': 'The biggest party one booking may take — on the website, over the phone and at the counter alike.',
  'settings.party.max': 'Most seats per booking',
  'settings.party.unit': 'seats',
  'settings.party.maxHint': 'A bigger party is refused with “please call the restaurant”, so a function is arranged by a person. 0 = no limit. Seating a walk-in is never limited by this.',
  'settings.noshow.title': 'Blacklist repeat no-shows',
  'settings.noshow.hint': 'A guest who books and never turns up leaves a table empty for the whole service. This is how many times before the website stops taking their bookings.',
  'settings.noshow.strikes': 'Blacklist after',
  'settings.noshow.strikesUnit': 'no-shows',
  'settings.noshow.strikesHint': 'Counted from the no-shows staff mark on the booking, by phone number. 0 = never blacklist anybody.',
  'settings.noshow.factMarkT': 'Only a person marks a no-show',
  'settings.noshow.factMark': 'nothing counts itself: staff press No show on the booking once the party has not come, and that is what adds up.',
  'settings.noshow.factLiftT': 'Staff lift it, on the guest’s CRM profile',
  'settings.noshow.factLift': 'lifting also puts the count back to zero, so the next no-show does not refuse them again straight away. Their lifetime no-show figure stays on the profile.',
  'settings.hold.how': 'How a held table runs',
  'settings.hold.factHeldT': 'Held, not booked',
  'settings.hold.factHeld': 'every board shows the table as blocked with the clock running, so nobody seats a walk-in on it and nobody mistakes it for a confirmed booking.',
  'settings.hold.factPayT': 'Paying books it',
  'settings.hold.factPay': 'inside the window the booking confirms itself — reception approves nothing.',
  'settings.hold.factFreeT': 'The window shutting frees it',
  'settings.hold.factFree': 'the booking cancels with a “payment window ran out” line in its history, the table goes back on the floor, and the lapse is noted on the guest’s profile.',
  // --- Shared across the Settings screens ----------------------------------
  'settings.eyebrow': 'Settings',
  'settings.view': 'View',
  'settings.close': 'Close',
  'settings.back': 'Back',
  'settings.error': 'Error',
  'settings.protected': 'Protected',
  'settings.readOnly': 'Read-only access.',

  // --- Locations: page shell -----------------------------------------------
  'settings.locations.eyebrow': 'Settings · Branches',
  'settings.locations.title': 'Locations',
  'settings.locations.addLocation': 'Add Location',
  'settings.locations.readOnlyBody': 'Your role can view locations but cannot edit them.',
  'settings.locations.noRestaurant': 'No restaurant selected. Pick a restaurant first to manage its locations.',
  'settings.locations.loading': 'Loading locations…',
  'settings.locations.loadFailed': 'Failed to load locations',
  'settings.locations.saveFailed': 'Failed to save',
  'settings.locations.reactivateFailed': 'Failed to reactivate',
  'settings.locations.deactivateFailed': 'Failed to deactivate',
  'settings.locations.confirmDeactivate': 'Deactivate location “{name}”? It can be reactivated by support.',

  // Validation shown above the editor tabs.
  'settings.locations.validation.name': 'Name is required',
  'settings.locations.validation.type': 'Location type is required. Pick one on the Location Type tab.',
  'settings.locations.validation.hours': 'Set operating hours for each day (open & close times, or mark the day closed).',

  // --- Locations: list ------------------------------------------------------
  'settings.locations.empty.title': 'No locations yet',
  'settings.locations.empty.body': 'Get started by adding your first location.',
  'settings.locations.primary': 'Primary',
  'settings.locations.reactivate': 'Reactivate',
  'settings.locations.copyLink': 'Copy link',

  // --- Locations: editor shell ---------------------------------------------
  'settings.locations.newLocation': 'New Location',
  'settings.locations.editorTitle.edit': 'Edit: {name}',
  'settings.locations.editorTitle.view': 'View: {name}',
  'settings.locations.fallbackName': 'Location',
  'settings.locations.tab.basic': 'Basic Settings',
  'settings.locations.tab.type': 'Location Type',
  'settings.locations.tab.hours': 'Hours',
  'settings.locations.tab.admins': 'Admins',
  'settings.locations.tab.seating': 'Floor Plan',
  'settings.locations.tab.soon': 'soon',

  // "Save the location before you can use this tab" placeholder.
  'settings.locations.saveFirst.title': 'Save this location first',
  'settings.locations.saveFirst.body': 'Fill in the basic info and click Save. Once the location exists, you can manage {what} here.',
  'settings.locations.saveFirst.what.floorPlan': 'the floor plan',
  'settings.locations.saveFirst.what.admins': 'admins',
  'settings.locations.saveFirst.what.adminsAndFloorPlan': 'admins and floor plan',

  // --- Locations: Basic tab -------------------------------------------------
  'settings.locations.field.name': 'Location Name',
  'settings.locations.field.namePlaceholder': 'e.g., Downtown Branch',
  'settings.locations.field.orderCode': 'Order Code',
  'settings.locations.openSite': 'Open',
  'settings.locations.copy': 'Copy',
  'settings.locations.field.phone': 'Phone',
  'settings.locations.field.reservationPhone': 'Table Reservation Number',
  'settings.locations.field.alternatePhone': 'Alternate Contact Number',
  'settings.locations.field.email': 'Email',
  'settings.locations.field.emailPlaceholder': 'branch@example.com',
  'settings.locations.field.postalCode': 'Postal Code',
  'settings.locations.field.address1': 'Address Line 1',
  'settings.locations.field.address1Placeholder': 'Street, building',
  'settings.locations.field.address2': 'Address Line 2',
  'settings.locations.field.address2Placeholder': 'Suite, floor (optional)',
  // --- Guest table finder (public site /near-me) ---------------------------
  'settings.locations.finder.title': 'Guest table finder (Near me)',
  'settings.locations.finder.latitude': 'Latitude',
  'settings.locations.finder.latitudeHint': 'WGS-84, 6 decimals. Mauritius runs from about −19.9 to −20.6.',
  'settings.locations.finder.longitude': 'Longitude',
  'settings.locations.finder.longitudeHint': 'WGS-84, 6 decimals. Mauritius runs from about 57.2 to 57.9.',
  'settings.locations.finder.areaLabel': 'Area label',
  'settings.locations.finder.areaLabelHint': 'The short address line on the finder card.',
  'settings.locations.finder.areaLabelPh': 'e.g. Caudan Waterfront',
  'settings.locations.finder.cuisineTag': 'Cuisine tag',
  'settings.locations.finder.cuisineTagHint': 'What this branch serves, in a few words.',
  'settings.locations.finder.cuisineTagPh': 'e.g. Seafood · à la carte',
  'settings.locations.finder.isPublic': 'List this branch on the public table finder',
  // --- Locality (island gazetteer, apps/geo) ------------------------------
  'settings.locations.locality.label': 'Locality',
  'settings.locations.locality.hint': 'The town, village or quarter the branch stands in. Its district follows from the island gazetteer.',
  'settings.locations.locality.placeholder': 'Pick a town or village…',
  'settings.locations.locality.search': 'Type to search…',
  'settings.locations.locality.empty': 'No town or village matches',
  'settings.locations.locality.none': '— Not set —',
  'settings.locations.locality.district': 'District: {district}',
  'settings.locations.field.city': 'City',
  'settings.locations.field.state': 'State / District',
  'settings.locations.field.country': 'Country',
  'settings.locations.field.countryPlaceholder': 'Mauritius',
  'settings.locations.field.isPrimary': 'Mark as primary location',
  'settings.locations.field.description': 'Description / Notes',
  'settings.locations.field.descriptionPlaceholder': 'Internal notes about this location…',

  // --- Locations: Type tab --------------------------------------------------
  'settings.locations.field.type': 'Location Type',
  'settings.locations.selectType': '— Select a type —',
  'settings.locations.aboutType': 'About {name}',
  'settings.locations.noTypes.before': 'No active location types yet. Go to',
  'settings.locations.noTypes.path': 'Settings → Master Data → Restaurant Types',
  'settings.locations.noTypes.after': 'to add some.',
  'settings.locations.payment.title': 'Payment',
  'settings.locations.payment.before': 'Pay when ordering',
  'settings.locations.payment.after': 'Pay after the order',
  'settings.locations.payment.beforeHint': 'Payment is taken while the order is being placed (counter / kiosk style).',
  'settings.locations.payment.afterHint': 'The bill is settled after the order is completed (classic dine-in).',

  // --- Locations: Hours tab -------------------------------------------------
  'settings.locations.day.monday': 'Monday',
  'settings.locations.day.tuesday': 'Tuesday',
  'settings.locations.day.wednesday': 'Wednesday',
  'settings.locations.day.thursday': 'Thursday',
  'settings.locations.day.friday': 'Friday',
  'settings.locations.day.saturday': 'Saturday',
  'settings.locations.day.sunday': 'Sunday',
  'settings.locations.hours.title': 'Operating Hours',
  'settings.locations.hours.applyMonday': 'Apply Monday’s hours to every day',
  'settings.locations.hours.reset': 'Reset hours',
  'settings.locations.hours.setMondayFirst': 'Set Monday first',
  'settings.locations.hours.setMondayFirstBody': 'Give Monday an open and close time (or mark it closed), then apply it to every day.',
  'settings.locations.hours.applied': 'Hours applied',
  'settings.locations.hours.appliedClosed': 'Every day is now marked closed (copied from Monday).',
  'settings.locations.hours.appliedRange': 'Every day is now {open}–{close} (copied from Monday).',
  'settings.locations.hours.notSet': 'Hours not set yet. Edit any day below to start — sections set to “follow working hours” will use these.',
  'settings.locations.hours.closed': 'Closed',
  'settings.locations.hours.closedAllDay': 'Closed all day',
  'settings.locations.hours.to': 'to',
  'settings.locations.lastOrder.title': 'Last order time',
  'settings.locations.lastOrder.modeOffset': 'Before closing time',
  'settings.locations.lastOrder.modeFixed': 'Same time every day',
  'settings.locations.lastOrder.prefix': 'Last orders',
  'settings.locations.lastOrder.suffix': 'minutes before closing',
  'settings.locations.lastOrder.at': 'Last order {time}',
  'settings.locations.lastOrder.closes': 'closes {time}',
  'settings.locations.lastOrder.setClosing': 'Set a closing time',
  'settings.locations.lastOrder.clear': 'Clear',
  'settings.locations.lastOrder.warnBefore': 'This is',
  'settings.locations.lastOrder.warnStrong': 'after closing',
  'settings.locations.lastOrder.warnAfter': 'on {days} — set it a little before the earliest close, or clear it.',

  // --- Locations: Admins tab ------------------------------------------------
  'settings.locations.admins.title': 'Location Admins',
  'settings.locations.admins.loading': 'Loading admins…',
  'settings.locations.admins.loadFailed': 'Failed to load admins',
  'settings.locations.admins.addFailed': 'Failed to add admin',
  'settings.locations.admins.removeFailed': 'Failed to remove admin',
  'settings.locations.admins.empty': 'No admins assigned yet. Add one below.',
  'settings.locations.admins.staffFallback': 'Staff #{id}',
  'settings.locations.admins.keepOne': 'A location must keep at least one admin',
  'settings.locations.admins.remove': 'Remove admin',
  'settings.locations.admins.addLabel': 'Add an admin',
  'settings.locations.admins.noneLeft': '— No more staff to add —',
  'settings.locations.admins.selectStaff': '— Select staff —',

  // --- Roles: page ----------------------------------------------------------
  'settings.roles.title': 'Roles',
  'settings.roles.subtitle': 'Create a role and pick the access level for each module. Each level grants the right permission codes behind the scenes.',
  'settings.roles.countOne': '1 role defined',
  'settings.roles.countMany': '{n} roles defined',
  'settings.roles.newRole': 'New Role',
  'settings.roles.colAccess': 'Access',
  'settings.roles.loadingRoles': 'Loading roles…',
  'settings.roles.loadFailed': 'Failed to load roles',
  'settings.roles.empty.before': 'No roles yet. Click',
  'settings.roles.empty.after': 'to create one.',
  'settings.roles.systemRole': 'System role',
  'settings.roles.editRole': 'Edit role',
  'settings.roles.deleteRole': 'Delete role',
  'settings.roles.confirmDelete': 'Delete role “{name}”? This cannot be undone.',
  'settings.roles.deleted': 'Role deleted',
  'settings.roles.deleteFailed': 'Delete failed',

  // --- Roles: editor --------------------------------------------------------
  'settings.roles.editTitle': 'Edit Role · {name}',
  'settings.roles.createTitle': 'Create New Role',
  'settings.roles.saveRole': 'Save Role',
  'settings.roles.field.name': 'Role Name',
  'settings.roles.field.namePlaceholder': 'e.g., Manager',
  'settings.roles.field.description': 'Short Description',
  'settings.roles.field.descriptionPlaceholder': 'What does this role do?',
  'settings.roles.validation.name': 'Role name is required',
  'settings.roles.updateFailed': 'Update failed',
  'settings.roles.createFailed': 'Create failed',
  'settings.roles.permsFailed': 'Saving permissions failed',
  'settings.roles.missingPerms': 'These permission codes are missing in the system: {codes}. Ask an admin to (re)seed them.',
  'settings.roles.updated': 'Role updated',
  'settings.roles.created': 'Role created',
  'settings.roles.moduleAccess': 'Module Access',
  'settings.roles.moduleAccessHint': 'Pick what this role can do in each module.',
  'settings.roles.colModule': 'Module',
  'settings.roles.colAccessLevel': 'Access Level',

  // Access levels — the label only; the stored value stays a server code.
  'settings.roles.level.none': 'No View',
  'settings.roles.level.view': 'View',
  'settings.roles.level.viewEdit': 'View + Edit',
  'settings.roles.level.create': 'Create',
  'settings.roles.level.edit': 'Edit',

  // Module names + one-line descriptions in the access matrix.
  'settings.roles.module.dashboard': 'Dashboard & Reports',
  'settings.roles.module.dashboard.desc': 'The dashboard and all report screens.',
  'settings.roles.module.ordersKitchen': 'Kitchen View',
  'settings.roles.module.ordersKitchen.desc': 'The kitchen order board (KDS) — accept, cook, mark ready.',
  'settings.roles.module.ordersManage': 'Order Management',
  'settings.roles.module.ordersManage.desc': 'Manage Orders / Active / All Orders (the billing side).',
  'settings.roles.module.dishes': 'Dishes',
  'settings.roles.module.dishes.desc': 'All Dishes — View includes ingredients & recipe (for the kitchen).',
  'settings.roles.module.menus': 'Menus & Buffets',
  'settings.roles.module.menus.desc': 'All Menus and Open Buffet management.',
  'settings.roles.module.inventory': 'Inventory',
  'settings.roles.module.inventory.desc': 'Item tracking, purchases, bar & liquor screens.',
  'settings.roles.module.tables': 'Tables',
  'settings.roles.module.tables.desc': 'Tables, reservations and table QR codes.',
  'settings.roles.module.customers': 'Customers',
  'settings.roles.module.customers.desc': 'Customer directory and CRM screens.',
  'settings.roles.module.staff': 'Staff',
  'settings.roles.module.staff.desc': 'Staff, roles and session screens.',
  'settings.roles.module.settingsOther': 'Other Settings',
  'settings.roles.module.settingsOther.desc': 'Tax rates, menu view and display settings.',
  'settings.roles.module.company': 'Company',
  'settings.roles.module.company.desc': 'Company Profile pages under Settings.',
  'settings.roles.module.locations': 'Locations',
  'settings.roles.module.locations.desc': 'Restaurant locations / branches.',
  'settings.roles.module.dataDisplay': 'Data Display',
  'settings.roles.module.dataDisplay.desc': 'Date/time/number/format display preferences.',
  'settings.roles.module.masterData': 'Master Data',
  'settings.roles.module.masterData.desc': 'Countries, currencies, languages, restaurant/company types.',

  // --- Staff list + add form ------------------------------------------------
  'settings.staff.title': 'Staff Members ({n})',
  'settings.staff.addStaff': 'Add Staff',
  'settings.staff.empty': 'No staff members found',
  'settings.staff.networkError': 'Network error: {msg}',
  'settings.staff.colEmail': 'Email',
  'settings.staff.colRole': 'Role',
  'settings.staff.colPhone': 'Phone',
  'settings.staff.noPos': 'No POS',
  'settings.staff.noPosTitle': 'Cannot sign in on the POS or Android app',
  'settings.staff.viewMember': 'View staff member',
  'settings.staff.editMember': 'Edit staff member',
  'settings.staff.addTitle': 'Add New Staff',
  'settings.staff.field.firstName': 'First Name',
  'settings.staff.field.lastName': 'Last Name',
  'settings.staff.field.email': 'Email',
  'settings.staff.field.phone': 'Phone',
  'settings.staff.field.username': 'Username',
  'settings.staff.field.employeeId': 'Employee ID',
  'settings.staff.field.employeeIdPlaceholder': 'e.g. EMP-014 (optional)',
  'settings.staff.field.posAccess': 'POS access',
  'settings.staff.posCheckbox': 'Can sign in on the POS',
  'settings.staff.posHint': 'The Windows POS and the Android app.',
  'settings.staff.field.password': 'Password',
  'settings.staff.field.passwordPlaceholder': 'Set a password',
  'settings.staff.showPassword': 'Show password',
  'settings.staff.hidePassword': 'Hide password',
  'settings.staff.field.role': 'Role',
  'settings.staff.selectRole': '— Select a role —',
  'settings.staff.noRoles.before': 'No assignable roles yet. Create one in',
  'settings.staff.noRoles.link': 'Staff → Roles',
  'settings.staff.noRoles.after': 'before adding non-admin staff.',

  // Validation for the inline "add staff" form.
  'settings.staff.missing.message': 'Please fill in the {list}.',
  'settings.staff.missing.and': 'and',
  'settings.staff.missing.firstName': 'first name',
  'settings.staff.missing.lastName': 'last name',
  'settings.staff.missing.email': 'email',
  'settings.staff.missing.username': 'username',
  'settings.staff.missing.role': 'role',
  'settings.staff.invalidEmail': 'That email address doesn’t look right — check it and try again.',
  'settings.staff.passwordRequired': 'Set a password, or switch POS access off for this person.',
  'settings.staff.noRestaurant': 'No restaurant selected — cannot create staff.',
  'settings.staff.addFailed': 'Failed to add staff',

  // --- App preferences (Data Display) --------------------------------------
  'settings.prefs.readOnlyBody': 'Your role can view these preferences but cannot change them.',
  'settings.prefs.noMatches': 'No matches',
  'settings.prefs.time24': '24-hour (14:30)',
  'settings.prefs.time24Seconds': '24-hour with seconds (14:30:00)',
  'settings.prefs.time12': '12-hour (02:30 PM)',
  'settings.prefs.time12Seconds': '12-hour with seconds (02:30:00 PM)',
  'settings.prefs.interfaceLanguage': 'Interface language',
  'settings.prefs.languageHint': 'Applies straight away on this device — nothing to save.',

  // --- Devices: pairing a machine before anybody signs in on it ------------
  'settings.devices.pair.button': 'Pair a device',
  'settings.devices.pair.title': 'Pair a device',
  'settings.devices.pair.blurb': 'Create a code and type it into the machine’s own set-up screen. The code carries the branch, so the terminal registers itself and knows where it stands — nobody has to sign in on it first.',
  'settings.devices.pair.branch': 'Branch this machine serves',
  'settings.devices.pair.branchHint': 'The machine takes this branch from the code — its orders, menus and printers all follow it.',
  'settings.devices.pair.type': 'Kind of machine',
  'settings.devices.pair.anyType': 'Any machine',
  'settings.devices.pair.expiry': 'Code lasts',
  'settings.devices.pair.mins30': '30 minutes',
  'settings.devices.pair.hours2': '2 hours',
  'settings.devices.pair.hours8': '8 hours',
  'settings.devices.pair.hours12': '12 hours',
  'settings.devices.pair.name': 'Name for this machine (optional)',
  'settings.devices.pair.namePlaceholder': 'e.g. Counter 1 POS',
  'settings.devices.pair.create': 'Create code',
  'settings.devices.pair.close': 'Close',
  'settings.devices.pair.cancel': 'Cancel',
  'settings.devices.pair.cancelTitle': 'Cancel this pairing code?',
  'settings.devices.pair.cancelBody': 'Code {code} stops working straight away. Anyone still setting a machine up with it will need a new one.',
  'settings.devices.pair.cancelConfirm': 'Cancel the code',
  'settings.devices.pair.cancelFailed': 'Could not cancel the code',
  'settings.devices.pair.needBranch': 'Choose a branch',
  'settings.devices.pair.needBranchBody': 'A pairing code always carries the branch the machine will serve.',
  'settings.devices.pair.mintFailed': 'Could not create the code',
  'settings.devices.pair.mintedBlurb': 'Type this into the machine’s set-up screen. It registers itself against {branch}.',
  'settings.devices.pair.copy': 'Copy',
  'settings.devices.pair.copied': 'Copied',
  'settings.devices.pair.expiresIn': 'Expires in {time}',
  'settings.devices.pair.step1': 'Start RestoBOXX POS, Kitchen or Kiosk on the machine.',
  'settings.devices.pair.step2': 'Check the server address it shows, and correct it if needed.',
  'settings.devices.pair.step3': 'Type this code and press Set up this machine.',
  'settings.devices.pair.oneUse': 'One machine per code: it stops working the moment it is used, and expires on its own.',
  'settings.devices.pair.another': 'Another code',
  'settings.devices.pair.done': 'Done',

  // --- Restaurant Groups: Company -> Restaurant Group -> Location ------------
  'settings.groups.eyebrow': 'Settings · Restaurant Groups',
  'settings.groups.title': 'Restaurant Groups',
  'settings.groups.intro': 'Your company runs its branches through restaurant groups — Company → Restaurant Group → Location. Create a group for each franchise or brand (or just one for the whole company) and map the branches it owns; every branch belongs to exactly one group.',
  'settings.groups.add': 'Add Group',
  'settings.groups.showInactive': 'Show inactive',
  'settings.groups.loading': 'Loading groups…',
  'settings.groups.loadFailed': 'Failed to load restaurant groups',
  'settings.groups.saveFailed': 'Failed to save',
  'settings.groups.deleteFailed': 'Failed to delete',
  'settings.groups.noRestaurant': 'No restaurant selected. Pick a restaurant first to manage its groups.',
  'settings.groups.readOnlyBody': 'Your role can view restaurant groups but cannot edit them.',
  'settings.groups.empty.title': 'No restaurant groups yet',
  'settings.groups.empty.body': 'Create your first group — a franchise, a brand, or simply one for the whole company — and map its branches to it. Every branch must belong to a group.',
  'settings.groups.ungroupedSummary': '{count} location(s) not in any group yet — every branch must belong to one. Open each under Settings → Locations and pick its group',
  'settings.groups.locationsCount': '{count} location(s)',
  'settings.groups.inactive': 'Inactive',
  'settings.groups.edit': 'Edit',
  'settings.groups.delete': 'Delete',
  'settings.groups.confirmDelete': 'Delete group “{name}”? Its branches must already have been moved out.',
  'settings.groups.confirmDeleteBtn': 'Delete',
  'settings.groups.newGroup': 'New Group',
  'settings.groups.editorTitle.edit': 'Edit: {name}',
  'settings.groups.editorTitle.view': 'View: {name}',
  'settings.groups.fallbackName': 'Group',
  'settings.groups.tab.details': 'Details',
  'settings.groups.tab.locations': 'Locations',
  'settings.groups.cancel': 'Cancel',
  'settings.groups.save': 'Save',
  'settings.groups.saving': 'Saving…',
  'settings.groups.field.name': 'Group name',
  'settings.groups.field.namePh': 'e.g., Northern Franchise',
  'settings.groups.field.code': 'Code',
  'settings.groups.field.codeHint': 'Short label for reports and pickers: letters and digits, up to 10.',
  'settings.groups.field.contact': 'Contact person',
  'settings.groups.field.phone': 'Phone',
  'settings.groups.field.email': 'Email',
  'settings.groups.field.description': 'Description / Notes',
  'settings.groups.field.descriptionPh': 'What this group is: brand, franchisee, region…',
  'settings.groups.field.color': 'Brand colour',
  'settings.groups.field.colorHint': 'Used on the public table finder: map pins, chips and card headings. Blank uses the site accent.',
  'settings.groups.field.active': 'Active',
  'settings.groups.validation.name': 'Group name is required',
  // --- Places (Near me): hotels, landmarks & the Popular six -------------
  'settings.places.eyebrow': 'Settings',
  'settings.places.title': 'Places (Near me)',
  'settings.places.intro': 'What a guest can type into the public table finder. Towns and villages come from the island gazetteer; hotels, landmarks and the airport are kept here. Popular is the six shown before anything is typed.',
  'settings.places.tab.landmarks': 'Hotels & landmarks',
  'settings.places.tab.popular': 'Popular',
  'settings.places.add': 'Add a place',
  'settings.places.showInactive': 'Show hidden places',
  'settings.places.loading': 'Loading…',
  'settings.places.loadFailed': 'Could not load the places.',
  'settings.places.saveFailed': 'Could not save.',
  'settings.places.noRestaurant': 'Pick a restaurant first.',
  'settings.places.readOnlyBody': 'You can look through the places but not change them.',
  'settings.places.empty.title': 'No hotels or landmarks yet',
  'settings.places.empty.body': 'Add the hotels and well-known spots guests name when they say where they are.',
  'settings.places.filterPh': 'Filter by name, district or other name',
  'settings.places.col.name': 'Place',
  'settings.places.col.type': 'Type',
  'settings.places.col.district': 'District',
  'settings.places.col.coords': 'Coordinates',
  'settings.places.col.aliases': 'Other names',
  'settings.places.col.status': 'Status',
  'settings.places.col.actions': 'Actions',
  'settings.places.active': 'Offered',
  'settings.places.inactive': 'Hidden',
  'settings.places.popularBadge': 'Popular no. {rank}',
  'settings.places.type.hotel': 'Hotel',
  'settings.places.type.landmark': 'Landmark',
  'settings.places.type.airport': 'Airport',
  'settings.places.edit': 'Edit',
  'settings.places.view': 'View',
  'settings.places.deactivate': 'Hide',
  'settings.places.confirmDeactivate': 'Hide {name} from the search? Nothing is deleted; you can show it again from the hidden list.',
  'settings.places.back': 'Back to the list',
  'settings.places.newTitle': 'New place',
  'settings.places.editTitle': 'Edit place',
  'settings.places.cancel': 'Cancel',
  'settings.places.save': 'Save',
  'settings.places.saving': 'Saving…',
  'settings.places.field.name': 'Name',
  'settings.places.field.namePh': 'e.g. LUX* Grand Baie',
  'settings.places.field.type': 'Type',
  'settings.places.field.district': 'District',
  'settings.places.field.districtPick': 'Pick a district',
  'settings.places.field.lat': 'Latitude',
  'settings.places.field.latHint': 'WGS-84, e.g. −20.4302',
  'settings.places.field.lng': 'Longitude',
  'settings.places.field.lngHint': 'WGS-84, e.g. 57.6836',
  'settings.places.field.aliases': 'Other names',
  'settings.places.field.aliasesHint': 'Comma-separated. Never shown, only searched: spellings and short names guests type.',
  'settings.places.field.aliasesPh': 'Lux Grand Bay, Grand Baie Lux',
  'settings.places.field.active': 'Offered in the search',
  'settings.places.validation.name': 'Name is required.',
  'settings.places.validation.district': 'Pick a district.',
  'settings.places.validation.coords': 'Latitude and longitude are required.',
  'settings.places.popular.intro': 'The {n} places offered the moment a guest taps the search box, before typing. Order them as they should appear.',
  'settings.places.popular.empty': 'Nothing is marked popular yet.',
  'settings.places.popular.count': '{n} of {limit} chosen',
  'settings.places.popular.searchPh': 'Add a town, hotel or landmark…',
  'settings.places.popular.noMatches': 'No place matches that.',
  'settings.places.popular.full': 'All {limit} spots are taken. Remove one to add another.',
  'settings.places.popular.up': 'Move up',
  'settings.places.popular.down': 'Move down',
  'settings.places.popular.remove': 'Remove',
  'settings.places.popular.save': 'Save the Popular list',
  'settings.places.popular.saved': 'Popular list saved.',
  'settings.groups.map.title': 'Branches in this group',
  'settings.groups.map.hint': 'Tick the branches this group owns; a ticked branch moves here from its current group. Every branch belongs to a group, so a branch already here only leaves by being ticked in its new group, or by changing the group on the branch itself.',
  'settings.groups.map.inGroup': 'now in {group}',
  'settings.groups.map.ungrouped': 'no group',
  'settings.groups.map.none': 'No branches mapped yet',
  'settings.groups.map.save': 'Save mapping',
  'settings.groups.map.saved': 'Mapping saved',
  'settings.groups.map.saveFirst': 'Save the group first, then map its branches here.',
  'settings.groups.map.noLocations': 'No active branches yet. Add them under Settings → Locations.',
  'settings.groups.map.primary': 'Primary',
  'settings.groups.map.selectAll': 'Select all',
  'settings.groups.map.locked': 'in this group — tick it in its new group to move it',
  'settings.groups.map.own.empty': 'No branches yet. Branches are created under Settings → Locations; pick this group on the branch form and it appears here.',
  'settings.groups.map.own.goto': 'Open Locations',
  'settings.groups.map.move.title': 'Move existing branches into this group',
  'settings.groups.map.move.hint': 'Tick a branch from another group to move it here. A branch already in this group only leaves by being ticked in its new group, or by changing the group on the branch itself.',
  'settings.groups.created': '{name} saved. Create its branches under Settings → Locations and pick this group on the branch form; they will appear on its Locations tab.',
  // Locations screen: the group picker and filter.
  'settings.locations.groupFilter.label': 'Group',
  'settings.locations.groupFilter.all': 'All groups',
  'settings.locations.groupFilter.none': 'No group',
  'settings.locations.field.group': 'Restaurant Group',
  'settings.locations.field.groupSelect': '— Select a group —',
  'settings.locations.field.groupHint': 'Every branch belongs to a restaurant group — the franchise or brand it runs under. Groups are created under Settings → Restaurant Groups.',
  'settings.locations.field.groupNoneYet': 'No restaurant groups yet. Create one first under',
  'settings.locations.field.groupNoneYetLink': 'Settings → Restaurant Groups',
  'settings.locations.validation.group': 'Restaurant group is required — every branch belongs to a group. Pick one on the Basic Settings tab.',
  'settings.locations.section.ungrouped': 'Not in a group yet',
  'settings.locations.section.count': '{count} location(s)',

};

export const fr = {
  'settings.tax.default': 'Par défaut',
  'settings.tax.defaultBadge': 'Par défaut',
  'settings.tax.makeDefault': 'Définir par défaut',
  'settings.tax.defaultClear': 'Retirer le défaut',
  'settings.tax.defaultForm': 'En faire la taxe par défaut — elle s’applique à chaque plat sans taxe propre',
  'settings.tax.defaultHint': 'Les taux par défaut s’appliquent à chaque plat sans taxe propre, sur la borne comme sur l’addition.',
  'settings.tax.defaultNone': 'Aucun n’est encore marqué : tous les taux actifs s’appliquent.',
  'settings.tax.defaultSaved': 'Taux par défaut mis à jour',
  'settings.tax.yes': 'Oui',
  'settings.tax.no': 'Non',
  'settings.resv.branch': 'Succursale',
  'settings.resv.branchOnly': 'Enregistré pour cette succursale uniquement — changez de succursale depuis le menu de votre compte, en haut à droite.',
  'settings.resv.noBranch': 'Aucune succursale sélectionnée. Choisissez-en une dans le menu de votre compte, en haut à droite, avant d’enregistrer ces règles.',
  'settings.resv.usingFallback': 'Cette succursale n’a pas encore ses propres règles : elle suit les règles du restaurant jusqu’à ce que vous enregistriez ici.',
  'settings.website.branchNeeded': 'Choisissez d’abord la succursale que représente le site (onglet Site) avant d’ouvrir ou fermer ses réservations.',
  'settings.website.urls.title': 'Vos adresses web',
  'settings.website.urls.hint': 'Servies à côté de cette administration sur votre propre domaine — pour les cartes, les profils sociaux et les codes QR.',
  'settings.website.urls.site': 'Site web public',
  'settings.website.urls.justbuffets': 'Just Buffets — les buffets ouverts, au prix par personne selon le jour',
  'settings.website.urls.open': 'Ouvrir',
  'settings.website.urls.copy': 'Copier',
  'settings.website.urls.copied': 'Copié',
  'settings.hold.payTitle': 'Table retenue pendant le paiement',
  'settings.hold.payHint': 'Avec un montant de réservation activé, une réservation en ligne prend sa table dès qu’elle est créée. Voici combien de temps elle la garde sans payer.',
  'settings.hold.minutes': 'Retenir la table pendant',
  'settings.hold.minutesHint': 'Compté dès la création de la réservation. 0 désactive le compte à rebours — la réservation attend alors le personnel, comme avant.',
  'settings.party.title': 'Taille du groupe',
  'settings.party.hint': 'Le plus grand groupe qu’une seule réservation peut prendre — sur le site, par téléphone et au comptoir.',
  'settings.party.max': 'Places maximum par réservation',
  'settings.party.unit': 'places',
  'settings.party.maxHint': 'Un groupe plus grand est refusé avec « veuillez appeler le restaurant », afin qu’une réception soit organisée de vive voix. 0 = sans limite. Installer un client de passage n’est jamais limité par ce réglage.',
  'settings.noshow.title': 'Liste noire pour absences répétées',
  'settings.noshow.hint': 'Un client qui réserve et ne vient jamais laisse une table vide tout le service. Voici combien de fois avant que le site cesse d’accepter ses réservations.',
  'settings.noshow.strikes': 'Liste noire après',
  'settings.noshow.strikesUnit': 'absences',
  'settings.noshow.strikesHint': 'Comptées à partir des absences signalées par le personnel sur la réservation, par numéro de téléphone. 0 = ne jamais mettre sur liste noire.',
  'settings.noshow.factMarkT': 'Seule une personne signale une absence',
  'settings.noshow.factMark': 'rien ne se compte tout seul : le personnel appuie sur « Absent » sur la réservation une fois le groupe non venu, et c’est cela qui s’additionne.',
  'settings.noshow.factLiftT': 'Le personnel la retire, sur la fiche CRM du client',
  'settings.noshow.factLift': 'le retrait remet aussi le compte à zéro, pour que la prochaine absence ne le refuse pas aussitôt. Son total d’absences reste visible sur sa fiche.',
  'settings.hold.how': 'Comment fonctionne une table retenue',
  'settings.hold.factHeldT': 'Retenue, pas réservée',
  'settings.hold.factHeld': 'chaque écran montre la table comme bloquée avec le compte à rebours, pour que personne n’y installe un client de passage ni ne la prenne pour une réservation confirmée.',
  'settings.hold.factPayT': 'Le paiement la réserve',
  'settings.hold.factPay': 'dans le délai, la réservation se confirme d’elle-même — la réception n’approuve rien.',
  'settings.hold.factFreeT': 'Le délai écoulé la libère',
  'settings.hold.factFree': 'la réservation est annulée avec une ligne « délai de paiement dépassé » dans son historique, la table revient en salle, et l’abandon est noté sur la fiche du client.',
  // --- Shared across the Settings screens ----------------------------------
  'settings.eyebrow': 'Paramètres',
  'settings.view': 'Voir',
  'settings.close': 'Fermer',
  'settings.back': 'Retour',
  'settings.error': 'Erreur',
  'settings.protected': 'Protégé',
  'settings.readOnly': 'Accès en lecture seule.',

  // --- Locations: page shell -----------------------------------------------
  'settings.locations.eyebrow': 'Paramètres · Succursales',
  'settings.locations.title': 'Établissements',
  'settings.locations.addLocation': 'Ajouter un établissement',
  'settings.locations.readOnlyBody': 'Votre rôle peut consulter les établissements mais pas les modifier.',
  'settings.locations.noRestaurant': 'Aucun restaurant sélectionné. Choisissez d\'abord un restaurant pour gérer ses établissements.',
  'settings.locations.loading': 'Chargement des établissements…',
  'settings.locations.loadFailed': 'Échec du chargement des établissements',
  'settings.locations.saveFailed': 'Échec de l\'enregistrement',
  'settings.locations.reactivateFailed': 'Échec de la réactivation',
  'settings.locations.deactivateFailed': 'Échec de la désactivation',
  'settings.locations.confirmDeactivate': 'Désactiver l\'établissement « {name} » ? Le support pourra le réactiver.',

  // Validation shown above the editor tabs.
  'settings.locations.validation.name': 'Le nom est requis',
  'settings.locations.validation.type': 'Le type d\'établissement est requis. Choisissez-en un dans l\'onglet Type d\'établissement.',
  'settings.locations.validation.hours': 'Renseignez les horaires de chaque jour (ouverture et fermeture, ou marquez le jour comme fermé).',

  // --- Locations: list ------------------------------------------------------
  'settings.locations.empty.title': 'Aucun établissement pour le moment',
  'settings.locations.empty.body': 'Commencez par ajouter votre premier établissement.',
  'settings.locations.primary': 'Principal',
  'settings.locations.reactivate': 'Réactiver',
  'settings.locations.copyLink': 'Copier le lien',

  // --- Locations: editor shell ---------------------------------------------
  'settings.locations.newLocation': 'Nouvel établissement',
  'settings.locations.editorTitle.edit': 'Modifier : {name}',
  'settings.locations.editorTitle.view': 'Voir : {name}',
  'settings.locations.fallbackName': 'Établissement',
  'settings.locations.tab.basic': 'Paramètres de base',
  'settings.locations.tab.type': 'Type d\'établissement',
  'settings.locations.tab.hours': 'Horaires',
  'settings.locations.tab.admins': 'Administrateurs',
  'settings.locations.tab.seating': 'Plan de salle',
  'settings.locations.tab.soon': 'bientôt',

  // "Save the location before you can use this tab" placeholder.
  'settings.locations.saveFirst.title': 'Enregistrez d\'abord cet établissement',
  'settings.locations.saveFirst.body': 'Remplissez les informations de base et cliquez sur Enregistrer. Une fois l\'établissement créé, vous pourrez gérer {what} ici.',
  'settings.locations.saveFirst.what.floorPlan': 'le plan de salle',
  'settings.locations.saveFirst.what.admins': 'les administrateurs',
  'settings.locations.saveFirst.what.adminsAndFloorPlan': 'les administrateurs et le plan de salle',

  // --- Locations: Basic tab -------------------------------------------------
  'settings.locations.field.name': 'Nom de l\'établissement',
  'settings.locations.field.namePlaceholder': 'ex. : Succursale du centre-ville',
  'settings.locations.field.orderCode': 'Code de commande',
  'settings.locations.openSite': 'Ouvrir',
  'settings.locations.copy': 'Copier',
  'settings.locations.field.phone': 'Téléphone',
  'settings.locations.field.reservationPhone': 'Numéro de réservation de table',
  'settings.locations.field.alternatePhone': 'Autre numéro de contact',
  'settings.locations.field.email': 'E-mail',
  'settings.locations.field.emailPlaceholder': 'succursale@exemple.com',
  'settings.locations.field.postalCode': 'Code postal',
  'settings.locations.field.address1': 'Adresse ligne 1',
  'settings.locations.field.address1Placeholder': 'Rue, bâtiment',
  'settings.locations.field.address2': 'Adresse ligne 2',
  'settings.locations.field.address2Placeholder': 'Bureau, étage (facultatif)',
  // --- Recherche de table (site public /near-me) --------------------------
  'settings.locations.finder.title': 'Recherche de table (Près de moi)',
  'settings.locations.finder.latitude': 'Latitude',
  'settings.locations.finder.latitudeHint': 'WGS-84, 6 décimales. Maurice s’étend d’environ −19,9 à −20,6.',
  'settings.locations.finder.longitude': 'Longitude',
  'settings.locations.finder.longitudeHint': 'WGS-84, 6 décimales. Maurice s’étend d’environ 57,2 à 57,9.',
  'settings.locations.finder.areaLabel': 'Libellé du quartier',
  'settings.locations.finder.areaLabelHint': 'La courte ligne d’adresse affichée sur la fiche.',
  'settings.locations.finder.areaLabelPh': 'ex. Caudan Waterfront',
  'settings.locations.finder.cuisineTag': 'Étiquette cuisine',
  'settings.locations.finder.cuisineTagHint': 'Ce que sert cette succursale, en quelques mots.',
  'settings.locations.finder.cuisineTagPh': 'ex. Fruits de mer · à la carte',
  'settings.locations.finder.isPublic': 'Afficher cette succursale sur la recherche de table publique',
  'settings.locations.locality.label': 'Localité',
  'settings.locations.locality.hint': 'La ville, le village ou le quartier où se trouve la succursale. Son district découle du répertoire de l’île.',
  'settings.locations.locality.placeholder': 'Choisissez une ville ou un village…',
  'settings.locations.locality.search': 'Tapez pour rechercher…',
  'settings.locations.locality.empty': 'Aucune ville ni village ne correspond',
  'settings.locations.locality.none': '— Non renseignée —',
  'settings.locations.locality.district': 'District : {district}',
  'settings.locations.field.city': 'Ville',
  'settings.locations.field.state': 'Région / District',
  'settings.locations.field.country': 'Pays',
  'settings.locations.field.countryPlaceholder': 'Maurice',
  'settings.locations.field.isPrimary': 'Définir comme établissement principal',
  'settings.locations.field.description': 'Description / Notes',
  'settings.locations.field.descriptionPlaceholder': 'Notes internes sur cet établissement…',

  // --- Locations: Type tab --------------------------------------------------
  'settings.locations.field.type': 'Type d\'établissement',
  'settings.locations.selectType': '— Sélectionner un type —',
  'settings.locations.aboutType': 'À propos de {name}',
  'settings.locations.noTypes.before': 'Aucun type d\'établissement actif. Allez dans',
  'settings.locations.noTypes.path': 'Paramètres → Données de référence → Types de restaurant',
  'settings.locations.noTypes.after': 'pour en ajouter.',
  'settings.locations.payment.title': 'Paiement',
  'settings.locations.payment.before': 'Payer à la commande',
  'settings.locations.payment.after': 'Payer après la commande',
  'settings.locations.payment.beforeHint': 'Le paiement est encaissé au moment de la commande (comptoir / borne).',
  'settings.locations.payment.afterHint': 'L\'addition est réglée une fois la commande terminée (service à table classique).',

  // --- Locations: Hours tab -------------------------------------------------
  'settings.locations.day.monday': 'Lundi',
  'settings.locations.day.tuesday': 'Mardi',
  'settings.locations.day.wednesday': 'Mercredi',
  'settings.locations.day.thursday': 'Jeudi',
  'settings.locations.day.friday': 'Vendredi',
  'settings.locations.day.saturday': 'Samedi',
  'settings.locations.day.sunday': 'Dimanche',
  'settings.locations.hours.title': 'Horaires d\'ouverture',
  'settings.locations.hours.applyMonday': 'Appliquer les horaires du lundi à tous les jours',
  'settings.locations.hours.reset': 'Réinitialiser les horaires',
  'settings.locations.hours.setMondayFirst': 'Renseignez d\'abord le lundi',
  'settings.locations.hours.setMondayFirstBody': 'Donnez au lundi une heure d\'ouverture et de fermeture (ou marquez-le fermé), puis appliquez-le à tous les jours.',
  'settings.locations.hours.applied': 'Horaires appliqués',
  'settings.locations.hours.appliedClosed': 'Tous les jours sont désormais marqués fermés (copiés du lundi).',
  'settings.locations.hours.appliedRange': 'Tous les jours sont désormais {open}–{close} (copiés du lundi).',
  'settings.locations.hours.notSet': 'Horaires non définis. Modifiez un jour ci-dessous pour commencer — les sections réglées sur « suivre les horaires d\'ouverture » les utiliseront.',
  'settings.locations.hours.closed': 'Fermé',
  'settings.locations.hours.closedAllDay': 'Fermé toute la journée',
  'settings.locations.hours.to': 'à',
  'settings.locations.lastOrder.title': 'Heure de dernière commande',
  'settings.locations.lastOrder.modeOffset': 'Avant l\'heure de fermeture',
  'settings.locations.lastOrder.modeFixed': 'Même heure tous les jours',
  'settings.locations.lastOrder.prefix': 'Dernières commandes',
  'settings.locations.lastOrder.suffix': 'minutes avant la fermeture',
  'settings.locations.lastOrder.at': 'Dernière commande {time}',
  'settings.locations.lastOrder.closes': 'ferme à {time}',
  'settings.locations.lastOrder.setClosing': 'Définissez une heure de fermeture',
  'settings.locations.lastOrder.clear': 'Effacer',
  'settings.locations.lastOrder.warnBefore': 'C\'est',
  'settings.locations.lastOrder.warnStrong': 'après la fermeture',
  'settings.locations.lastOrder.warnAfter': 'le {days} — choisissez une heure un peu avant la fermeture la plus tôt, ou effacez-la.',

  // --- Locations: Admins tab ------------------------------------------------
  'settings.locations.admins.title': 'Administrateurs de l\'établissement',
  'settings.locations.admins.loading': 'Chargement des administrateurs…',
  'settings.locations.admins.loadFailed': 'Échec du chargement des administrateurs',
  'settings.locations.admins.addFailed': 'Échec de l\'ajout de l\'administrateur',
  'settings.locations.admins.removeFailed': 'Échec du retrait de l\'administrateur',
  'settings.locations.admins.empty': 'Aucun administrateur assigné. Ajoutez-en un ci-dessous.',
  'settings.locations.admins.staffFallback': 'Employé n° {id}',
  'settings.locations.admins.keepOne': 'Un établissement doit garder au moins un administrateur',
  'settings.locations.admins.remove': 'Retirer l\'administrateur',
  'settings.locations.admins.addLabel': 'Ajouter un administrateur',
  'settings.locations.admins.noneLeft': '— Plus aucun membre du personnel à ajouter —',
  'settings.locations.admins.selectStaff': '— Sélectionner un employé —',

  // --- Roles: page ----------------------------------------------------------
  'settings.roles.title': 'Rôles',
  'settings.roles.subtitle': 'Créez un rôle et choisissez le niveau d\'accès pour chaque module. Chaque niveau accorde les codes de permission correspondants en arrière-plan.',
  'settings.roles.countOne': '1 rôle défini',
  'settings.roles.countMany': '{n} rôles définis',
  'settings.roles.newRole': 'Nouveau rôle',
  'settings.roles.colAccess': 'Accès',
  'settings.roles.loadingRoles': 'Chargement des rôles…',
  'settings.roles.loadFailed': 'Échec du chargement des rôles',
  'settings.roles.empty.before': 'Aucun rôle pour le moment. Cliquez sur',
  'settings.roles.empty.after': 'pour en créer un.',
  'settings.roles.systemRole': 'Rôle système',
  'settings.roles.editRole': 'Modifier le rôle',
  'settings.roles.deleteRole': 'Supprimer le rôle',
  'settings.roles.confirmDelete': 'Supprimer le rôle « {name} » ? Cette action est irréversible.',
  'settings.roles.deleted': 'Rôle supprimé',
  'settings.roles.deleteFailed': 'Échec de la suppression',

  // --- Roles: editor --------------------------------------------------------
  'settings.roles.editTitle': 'Modifier le rôle · {name}',
  'settings.roles.createTitle': 'Créer un nouveau rôle',
  'settings.roles.saveRole': 'Enregistrer le rôle',
  'settings.roles.field.name': 'Nom du rôle',
  'settings.roles.field.namePlaceholder': 'ex. : Responsable',
  'settings.roles.field.description': 'Brève description',
  'settings.roles.field.descriptionPlaceholder': 'Que fait ce rôle ?',
  'settings.roles.validation.name': 'Le nom du rôle est requis',
  'settings.roles.updateFailed': 'Échec de la mise à jour',
  'settings.roles.createFailed': 'Échec de la création',
  'settings.roles.permsFailed': 'Échec de l\'enregistrement des permissions',
  'settings.roles.missingPerms': 'Ces codes de permission sont absents du système : {codes}. Demandez à un administrateur de les (ré)initialiser.',
  'settings.roles.updated': 'Rôle mis à jour',
  'settings.roles.created': 'Rôle créé',
  'settings.roles.moduleAccess': 'Accès aux modules',
  'settings.roles.moduleAccessHint': 'Choisissez ce que ce rôle peut faire dans chaque module.',
  'settings.roles.colModule': 'Module',
  'settings.roles.colAccessLevel': 'Niveau d\'accès',

  // Access levels — the label only; the stored value stays a server code.
  'settings.roles.level.none': 'Aucun accès',
  'settings.roles.level.view': 'Consulter',
  'settings.roles.level.viewEdit': 'Consulter + modifier',
  'settings.roles.level.create': 'Créer',
  'settings.roles.level.edit': 'Modifier',

  // Module names + one-line descriptions in the access matrix.
  'settings.roles.module.dashboard': 'Tableau de bord et rapports',
  'settings.roles.module.dashboard.desc': 'Le tableau de bord et tous les écrans de rapports.',
  'settings.roles.module.ordersKitchen': 'Vue cuisine',
  'settings.roles.module.ordersKitchen.desc': 'Le tableau des commandes en cuisine (KDS) — accepter, préparer, marquer prêt.',
  'settings.roles.module.ordersManage': 'Gestion des commandes',
  'settings.roles.module.ordersManage.desc': 'Gérer les commandes / Actives / Toutes les commandes (côté facturation).',
  'settings.roles.module.dishes': 'Plats',
  'settings.roles.module.dishes.desc': 'Tous les plats — la consultation inclut les ingrédients et la recette (pour la cuisine).',
  'settings.roles.module.menus': 'Menus et buffets',
  'settings.roles.module.menus.desc': 'Gestion de tous les menus et du buffet à volonté.',
  'settings.roles.module.inventory': 'Stock',
  'settings.roles.module.inventory.desc': 'Suivi des articles, achats, écrans bar et alcools.',
  'settings.roles.module.tables': 'Tables',
  'settings.roles.module.tables.desc': 'Tables, réservations et codes QR des tables.',
  'settings.roles.module.customers': 'Clients',
  'settings.roles.module.customers.desc': 'Répertoire des clients et écrans CRM.',
  'settings.roles.module.staff': 'Personnel',
  'settings.roles.module.staff.desc': 'Personnel, rôles et écrans de sessions.',
  'settings.roles.module.settingsOther': 'Autres paramètres',
  'settings.roles.module.settingsOther.desc': 'Taux de taxe, affichage du menu et paramètres d\'affichage.',
  'settings.roles.module.company': 'Entreprise',
  'settings.roles.module.company.desc': 'Pages du profil de l\'entreprise dans les Paramètres.',
  'settings.roles.module.locations': 'Établissements',
  'settings.roles.module.locations.desc': 'Établissements / succursales du restaurant.',
  'settings.roles.module.dataDisplay': 'Affichage des données',
  'settings.roles.module.dataDisplay.desc': 'Préférences d\'affichage des dates, heures, nombres et formats.',
  'settings.roles.module.masterData': 'Données de référence',
  'settings.roles.module.masterData.desc': 'Pays, devises, langues, types de restaurant et d\'entreprise.',

  // --- Staff list + add form ------------------------------------------------
  'settings.staff.title': 'Membres du personnel ({n})',
  'settings.staff.addStaff': 'Ajouter un employé',
  'settings.staff.empty': 'Aucun membre du personnel trouvé',
  'settings.staff.networkError': 'Erreur réseau : {msg}',
  'settings.staff.colEmail': 'E-mail',
  'settings.staff.colRole': 'Rôle',
  'settings.staff.colPhone': 'Téléphone',
  'settings.staff.noPos': 'Sans POS',
  'settings.staff.noPosTitle': 'Ne peut pas se connecter sur le POS ni sur l\'application Android',
  'settings.staff.viewMember': 'Voir le membre du personnel',
  'settings.staff.editMember': 'Modifier le membre du personnel',
  'settings.staff.addTitle': 'Ajouter un nouvel employé',
  'settings.staff.field.firstName': 'Prénom',
  'settings.staff.field.lastName': 'Nom',
  'settings.staff.field.email': 'E-mail',
  'settings.staff.field.phone': 'Téléphone',
  'settings.staff.field.username': 'Nom d\'utilisateur',
  'settings.staff.field.employeeId': 'Matricule',
  'settings.staff.field.employeeIdPlaceholder': 'ex. EMP-014 (facultatif)',
  'settings.staff.field.posAccess': 'Accès POS',
  'settings.staff.posCheckbox': 'Peut se connecter sur le POS',
  'settings.staff.posHint': 'Le POS Windows et l\'application Android.',
  'settings.staff.field.password': 'Mot de passe',
  'settings.staff.field.passwordPlaceholder': 'Définir un mot de passe',
  'settings.staff.showPassword': 'Afficher le mot de passe',
  'settings.staff.hidePassword': 'Masquer le mot de passe',
  'settings.staff.field.role': 'Rôle',
  'settings.staff.selectRole': '— Sélectionner un rôle —',
  'settings.staff.noRoles.before': 'Aucun rôle attribuable pour le moment. Créez-en un dans',
  'settings.staff.noRoles.link': 'Personnel → Rôles',
  'settings.staff.noRoles.after': 'avant d\'ajouter du personnel non administrateur.',

  // Validation for the inline "add staff" form.
  'settings.staff.missing.message': 'Veuillez renseigner {list}.',
  'settings.staff.missing.and': 'et',
  'settings.staff.missing.firstName': 'le prénom',
  'settings.staff.missing.lastName': 'le nom',
  'settings.staff.missing.email': 'l\'e-mail',
  'settings.staff.missing.username': 'le nom d\'utilisateur',
  'settings.staff.missing.role': 'le rôle',
  'settings.staff.invalidEmail': 'Cette adresse e-mail semble incorrecte — vérifiez-la et réessayez.',
  'settings.staff.passwordRequired': 'Définissez un mot de passe, ou désactivez l\'accès POS pour cette personne.',
  'settings.staff.noRestaurant': 'Aucun restaurant sélectionné — impossible de créer un employé.',
  'settings.staff.addFailed': 'Échec de l\'ajout de l\'employé',

  // --- App preferences (Data Display) --------------------------------------
  'settings.prefs.readOnlyBody': 'Votre rôle peut consulter ces préférences mais pas les modifier.',
  'settings.prefs.noMatches': 'Aucun résultat',
  'settings.prefs.time24': '24 heures (14:30)',
  'settings.prefs.time24Seconds': '24 heures avec secondes (14:30:00)',
  'settings.prefs.time12': '12 heures (02:30 PM)',
  'settings.prefs.time12Seconds': '12 heures avec secondes (02:30:00 PM)',
  'settings.prefs.interfaceLanguage': 'Langue de l\'interface',
  'settings.prefs.languageHint': 'S\'applique immédiatement sur cet appareil — rien à enregistrer.',

  // --- Devices: pairing a machine before anybody signs in on it ------------
  'settings.devices.pair.button': 'Appairer un appareil',
  'settings.devices.pair.title': 'Appairer un appareil',
  'settings.devices.pair.blurb': 'Créez un code et saisissez-le sur l’écran de configuration de la machine. Le code porte la succursale : le terminal s’enregistre lui-même et sait où il se trouve — personne n’a besoin de s’y connecter d’abord.',
  'settings.devices.pair.branch': 'Succursale desservie par cette machine',
  'settings.devices.pair.branchHint': 'La machine reçoit cette succursale par le code — ses commandes, ses menus et ses imprimantes la suivent.',
  'settings.devices.pair.type': 'Type de machine',
  'settings.devices.pair.anyType': 'Toute machine',
  'settings.devices.pair.expiry': 'Validité du code',
  'settings.devices.pair.mins30': '30 minutes',
  'settings.devices.pair.hours2': '2 heures',
  'settings.devices.pair.hours8': '8 heures',
  'settings.devices.pair.hours12': '12 heures',
  'settings.devices.pair.name': 'Nom de cette machine (facultatif)',
  'settings.devices.pair.namePlaceholder': 'ex. Caisse 1 POS',
  'settings.devices.pair.create': 'Créer le code',
  'settings.devices.pair.close': 'Fermer',
  'settings.devices.pair.cancel': 'Annuler',
  'settings.devices.pair.cancelTitle': 'Annuler ce code d’appairage ?',
  'settings.devices.pair.cancelBody': 'Le code {code} cesse de fonctionner immédiatement. Toute personne en train de configurer une machine avec devra en demander un nouveau.',
  'settings.devices.pair.cancelConfirm': 'Annuler le code',
  'settings.devices.pair.cancelFailed': 'Impossible d’annuler le code',
  'settings.devices.pair.needBranch': 'Choisissez une succursale',
  'settings.devices.pair.needBranchBody': 'Un code d’appairage porte toujours la succursale que la machine desservira.',
  'settings.devices.pair.mintFailed': 'Impossible de créer le code',
  'settings.devices.pair.mintedBlurb': 'Saisissez ceci sur l’écran de configuration de la machine. Elle s’enregistre sur {branch}.',
  'settings.devices.pair.copy': 'Copier',
  'settings.devices.pair.copied': 'Copié',
  'settings.devices.pair.expiresIn': 'Expire dans {time}',
  'settings.devices.pair.step1': 'Lancez RestoBOXX POS, Kitchen ou Kiosk sur la machine.',
  'settings.devices.pair.step2': 'Vérifiez l’adresse du serveur affichée et corrigez-la si nécessaire.',
  'settings.devices.pair.step3': 'Saisissez ce code et appuyez sur Configurer cette machine.',
  'settings.devices.pair.oneUse': 'Un code, une machine : il cesse de fonctionner dès qu’il est utilisé et expire de lui-même.',
  'settings.devices.pair.another': 'Un autre code',
  'settings.devices.pair.done': 'Terminé',
  // --- Groupes de restaurants : Société -> Groupe -> Succursale --------------
  'settings.groups.eyebrow': 'Paramètres · Groupes de restaurants',
  'settings.groups.title': 'Groupes de restaurants',
  'settings.groups.intro': 'Votre société gère ses succursales à travers des groupes de restaurants — Société → Groupe de restaurants → Emplacement. Créez un groupe par franchise ou enseigne (ou un seul pour toute la société) et associez-lui ses succursales ; chaque succursale appartient à exactement un groupe.',
  'settings.groups.add': 'Ajouter un groupe',
  'settings.groups.showInactive': 'Afficher les inactifs',
  'settings.groups.loading': 'Chargement des groupes…',
  'settings.groups.loadFailed': 'Impossible de charger les groupes',
  'settings.groups.saveFailed': 'Échec de l’enregistrement',
  'settings.groups.deleteFailed': 'Échec de la suppression',
  'settings.groups.noRestaurant': 'Aucun restaurant sélectionné. Choisissez d’abord un restaurant pour gérer ses groupes.',
  'settings.groups.readOnlyBody': 'Votre rôle peut consulter les groupes mais pas les modifier.',
  'settings.groups.empty.title': 'Aucun groupe pour le moment',
  'settings.groups.empty.body': 'Créez votre premier groupe — une franchise, une enseigne, ou simplement un pour toute la société — et associez-lui ses succursales. Chaque succursale doit appartenir à un groupe.',
  'settings.groups.ungroupedSummary': '{count} succursale(s) encore sans groupe — chaque succursale doit en avoir un. Ouvrez-les sous Paramètres → Emplacements et choisissez leur groupe',
  'settings.groups.locationsCount': '{count} succursale(s)',
  'settings.groups.inactive': 'Inactif',
  'settings.groups.edit': 'Modifier',
  'settings.groups.delete': 'Supprimer',
  'settings.groups.confirmDelete': 'Supprimer le groupe « {name} » ? Ses succursales doivent déjà avoir été déplacées.',
  'settings.groups.confirmDeleteBtn': 'Supprimer',
  'settings.groups.newGroup': 'Nouveau groupe',
  'settings.groups.editorTitle.edit': 'Modifier : {name}',
  'settings.groups.editorTitle.view': 'Consulter : {name}',
  'settings.groups.fallbackName': 'Groupe',
  'settings.groups.tab.details': 'Détails',
  'settings.groups.tab.locations': 'Succursales',
  'settings.groups.cancel': 'Annuler',
  'settings.groups.save': 'Enregistrer',
  'settings.groups.saving': 'Enregistrement…',
  'settings.groups.field.name': 'Nom du groupe',
  'settings.groups.field.namePh': 'ex. : Franchise du Nord',
  'settings.groups.field.code': 'Code',
  'settings.groups.field.codeHint': 'Libellé court pour les rapports et les listes : lettres et chiffres, 10 au maximum.',
  'settings.groups.field.contact': 'Personne de contact',
  'settings.groups.field.phone': 'Téléphone',
  'settings.groups.field.email': 'E-mail',
  'settings.groups.field.description': 'Description / Notes',
  'settings.groups.field.descriptionPh': 'Ce qu’est ce groupe : enseigne, franchisé, région…',
  'settings.groups.field.color': 'Couleur de l’enseigne',
  'settings.groups.field.colorHint': 'Utilisée sur la recherche de table publique : repères, puces et en-têtes de fiche. Vide = couleur du site.',
  'settings.groups.field.active': 'Actif',
  'settings.groups.validation.name': 'Le nom du groupe est requis',
  // --- Lieux (Près de moi) : hôtels, repères & les six Populaires ---------
  'settings.places.eyebrow': 'Paramètres',
  'settings.places.title': 'Lieux (Près de moi)',
  'settings.places.intro': 'Ce qu’un client peut saisir dans la recherche de table publique. Les villes et villages viennent du répertoire de l’île ; les hôtels, repères et l’aéroport se gèrent ici. Populaires : les six proposés avant toute saisie.',
  'settings.places.tab.landmarks': 'Hôtels & repères',
  'settings.places.tab.popular': 'Populaires',
  'settings.places.add': 'Ajouter un lieu',
  'settings.places.showInactive': 'Afficher les lieux masqués',
  'settings.places.loading': 'Chargement…',
  'settings.places.loadFailed': 'Impossible de charger les lieux.',
  'settings.places.saveFailed': 'Enregistrement impossible.',
  'settings.places.noRestaurant': 'Choisissez d’abord un restaurant.',
  'settings.places.readOnlyBody': 'Vous pouvez consulter les lieux, mais pas les modifier.',
  'settings.places.empty.title': 'Aucun hôtel ni repère pour l’instant',
  'settings.places.empty.body': 'Ajoutez les hôtels et lieux connus que les clients citent pour dire où ils se trouvent.',
  'settings.places.filterPh': 'Filtrer par nom, district ou autre nom',
  'settings.places.col.name': 'Lieu',
  'settings.places.col.type': 'Type',
  'settings.places.col.district': 'District',
  'settings.places.col.coords': 'Coordonnées',
  'settings.places.col.aliases': 'Autres noms',
  'settings.places.col.status': 'Statut',
  'settings.places.col.actions': 'Actions',
  'settings.places.active': 'Proposé',
  'settings.places.inactive': 'Masqué',
  'settings.places.popularBadge': 'Populaire n° {rank}',
  'settings.places.type.hotel': 'Hôtel',
  'settings.places.type.landmark': 'Repère',
  'settings.places.type.airport': 'Aéroport',
  'settings.places.edit': 'Modifier',
  'settings.places.view': 'Voir',
  'settings.places.deactivate': 'Masquer',
  'settings.places.confirmDeactivate': 'Masquer {name} de la recherche ? Rien n’est supprimé ; vous pourrez le réafficher depuis la liste des masqués.',
  'settings.places.back': 'Retour à la liste',
  'settings.places.newTitle': 'Nouveau lieu',
  'settings.places.editTitle': 'Modifier le lieu',
  'settings.places.cancel': 'Annuler',
  'settings.places.save': 'Enregistrer',
  'settings.places.saving': 'Enregistrement…',
  'settings.places.field.name': 'Nom',
  'settings.places.field.namePh': 'ex. LUX* Grand Baie',
  'settings.places.field.type': 'Type',
  'settings.places.field.district': 'District',
  'settings.places.field.districtPick': 'Choisir un district',
  'settings.places.field.lat': 'Latitude',
  'settings.places.field.latHint': 'WGS-84, ex. −20,4302',
  'settings.places.field.lng': 'Longitude',
  'settings.places.field.lngHint': 'WGS-84, ex. 57,6836',
  'settings.places.field.aliases': 'Autres noms',
  'settings.places.field.aliasesHint': 'Séparés par des virgules. Jamais affichés, seulement recherchés : orthographes et noms courts que les clients tapent.',
  'settings.places.field.aliasesPh': 'Lux Grand Bay, Grand Baie Lux',
  'settings.places.field.active': 'Proposé dans la recherche',
  'settings.places.validation.name': 'Le nom est requis.',
  'settings.places.validation.district': 'Choisissez un district.',
  'settings.places.validation.coords': 'La latitude et la longitude sont requises.',
  'settings.places.popular.intro': 'Les {n} lieux proposés dès que le client touche la zone de recherche, avant de taper. Classez-les dans l’ordre d’affichage.',
  'settings.places.popular.empty': 'Aucun lieu n’est encore marqué populaire.',
  'settings.places.popular.count': '{n} sur {limit} choisis',
  'settings.places.popular.searchPh': 'Ajouter une ville, un hôtel ou un repère…',
  'settings.places.popular.noMatches': 'Aucun lieu ne correspond.',
  'settings.places.popular.full': 'Les {limit} places sont prises. Retirez-en un pour en ajouter un autre.',
  'settings.places.popular.up': 'Monter',
  'settings.places.popular.down': 'Descendre',
  'settings.places.popular.remove': 'Retirer',
  'settings.places.popular.save': 'Enregistrer la liste Populaires',
  'settings.places.popular.saved': 'Liste Populaires enregistrée.',
  'settings.groups.map.title': 'Succursales de ce groupe',
  'settings.groups.map.hint': 'Cochez les succursales détenues par ce groupe ; une succursale cochée y est déplacée depuis son groupe actuel. Chaque succursale appartient à un groupe : une succursale déjà ici ne le quitte qu’en étant cochée dans son nouveau groupe, ou en changeant le groupe sur sa propre fiche.',
  'settings.groups.map.inGroup': 'actuellement dans {group}',
  'settings.groups.map.ungrouped': 'sans groupe',
  'settings.groups.map.none': 'Aucune succursale associée',
  'settings.groups.map.save': 'Enregistrer l’association',
  'settings.groups.map.saved': 'Association enregistrée',
  'settings.groups.map.saveFirst': 'Enregistrez d’abord le groupe, puis associez-lui ses succursales ici.',
  'settings.groups.map.noLocations': 'Aucune succursale active. Ajoutez-en sous Paramètres → Emplacements.',
  'settings.groups.map.primary': 'Principale',
  'settings.groups.map.selectAll': 'Tout cocher',
  'settings.groups.map.locked': 'dans ce groupe — cochez-la dans son nouveau groupe pour la déplacer',
  'settings.groups.map.own.empty': 'Aucune succursale pour l’instant. Les succursales se créent sous Paramètres → Emplacements ; choisissez ce groupe sur la fiche de la succursale et elle apparaît ici.',
  'settings.groups.map.own.goto': 'Ouvrir Emplacements',
  'settings.groups.map.move.title': 'Déplacer des succursales existantes dans ce groupe',
  'settings.groups.map.move.hint': 'Cochez une succursale d’un autre groupe pour la déplacer ici. Une succursale déjà dans ce groupe ne le quitte qu’en étant cochée dans son nouveau groupe, ou en changeant le groupe sur la succursale elle-même.',
  'settings.groups.created': '{name} enregistré. Créez ses succursales sous Paramètres → Emplacements en choisissant ce groupe sur la fiche ; elles apparaîtront dans son onglet Succursales.',
  // Écran Emplacements : sélecteur et filtre de groupe.
  'settings.locations.groupFilter.label': 'Groupe',
  'settings.locations.groupFilter.all': 'Tous les groupes',
  'settings.locations.groupFilter.none': 'Sans groupe',
  'settings.locations.field.group': 'Groupe de restaurants',
  'settings.locations.field.groupSelect': '— Choisir un groupe —',
  'settings.locations.field.groupHint': 'Chaque succursale appartient à un groupe de restaurants — la franchise ou l’enseigne dont elle dépend. Les groupes se créent sous Paramètres → Groupes de restaurants.',
  'settings.locations.field.groupNoneYet': 'Aucun groupe de restaurants pour le moment. Créez-en d’abord un sous',
  'settings.locations.field.groupNoneYetLink': 'Paramètres → Groupes de restaurants',
  'settings.locations.validation.group': 'Le groupe de restaurants est requis — chaque succursale appartient à un groupe. Choisissez-en un dans l’onglet Paramètres de base.',
  'settings.locations.section.ungrouped': 'Pas encore dans un groupe',
  'settings.locations.section.count': '{count} succursale(s)',
};
